import AccessibilityHelper from '../../00_utilities/helpers/AccessibilityHelper';

class MenuToggle {
    constructor(elem) {
        this.elem = elem;
    }

    init() {
        if (!this.elem.classList.contains('info-box__toggle')) {
            const associatedInput = document.getElementById(this.elem.getAttribute('for'));
            AccessibilityHelper.addAndHandleLabelsToggle('checkbox', associatedInput);
        }
    }
}

export default MenuToggle;
